import { AuthGuard, NonAuthGuard, RouteExtended } from '@controladad/ng-base';

export const appRoutes: RouteExtended[] = [
  {
    path: 'login',
    loadComponent: () => import('@panel').then((t) => t.LoginComponent),
    canActivate: [NonAuthGuard],
  },
  {
    path: '',
    layout: 'main',
    loadComponent: () => import('@panel').then((t) => t.MainLayoutComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'orders',
        pathMatch: 'full',
      },
      {
        path: 'orders',
        view: {
          label: 'Orders',
          icon: { default: 'receipt-2', active: 'receipt-2' },
        },
        data: { isAdmin: false },
        loadComponent: () => import('@panel').then((t) => t.OrdersComponent),
      },
      {
        path: 'products',
        view: {
          label: 'Products',
          icon: { default: 'box', active: 'box' },
        },
        data: { isAdmin: false },
        loadComponent: () => import('@panel').then((t) => t.ProductsComponent),
      },
    ],
  },
];
